import { Injectable } from '@angular/core';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class UrlStateService {

  constructor(private location: Location) {}

  updateQueryParams(params: Record<string, string | number | null>, basePath?: string): void {
    const currentPath = basePath || this.getCurrentPath();
    const currentParams = this.getCurrentQueryParams();
    const updatedParams = { ...currentParams };
    Object.entries(params).forEach(([key, value]) => {
      if (value === null || value === undefined) {
        delete updatedParams[key];
      } else {
        updatedParams[key] = String(value);
      }
    });
    const queryString = this.buildQueryString(updatedParams);
    const newUrl = queryString ? `${currentPath}?${queryString}` : currentPath;
    this.location.replaceState(newUrl);
  }

  clearQueryParams(basePath?: string): void {
    const currentPath = basePath || this.getCurrentPath();
    this.location.replaceState(currentPath);
  }

  getQueryParam(key: string): string | null {
    const params = this.getCurrentQueryParams();
    return params[key] || null;
  }

  getCurrentQueryParams(): Record<string, string> {
    const url = this.location.path();
    const queryIndex = url.indexOf('?');
    if (queryIndex === -1) {return {};}
    const queryString = url.substring(queryIndex + 1);
    const params: Record<string, string> = {};
    queryString.split('&').forEach(pair => {
      const [key, value] = pair.split('=');
      if (key) {
        params[decodeURIComponent(key)] = decodeURIComponent(value || '');
      }
    });
    return params;
  }

  private getCurrentPath(): string {
    const url = this.location.path();
    const queryIndex = url.indexOf('?');
    return queryIndex === -1 ? url : url.substring(0, queryIndex);
  }

  private buildQueryString(params: Record<string, string>): string {
    return Object.entries(params)
      .filter(([_, value]) => value !== undefined && value !== null)
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join('&');
  }
}
